import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i-946376999__a)" }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M4 2.075A1.925 1.925 0 0 0 2.075 4v4A1.925 1.925 0 0 0 4 9.925h4A1.925 1.925 0 0 0 9.925 8V4A1.925 1.925 0 0 0 8 2.075zm-2.174-.25A3.08 3.08 0 0 1 4 .926h4A3.075 3.075 0 0 1 11.075 4v4A3.075 3.075 0 0 1 8 11.075H4A3.075 3.075 0 0 1 .925 8V4c0-.816.324-1.598.9-2.174M5.997 3.25a.75.75 0 1 0 .006 1.5.75.75 0 0 0-.006-1.5m-.372 1.892a.575.575 0 0 0-.075 1.145v1.805a.575.575 0 0 0 1.15 0V5.717a.575.575 0 0 0-.575-.575z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-946376999__a" }, [
        _createElementVNode("path", { d: "M0 0h12v12H0z" })
      ])
    ], -1)
  ])))
}
export default { render: render }